
export default function extendGantt(gantt: any, dp: any) {
	gantt.getUserData = function(id, name) {
		if (!this.userdata) {
			this.userdata = {};
		}
		if (this.userdata[id] && this.userdata[id][name]) {
			return this.userdata[id][name];
		}
		return "";
	};
	gantt.setUserData = function(id, name, value) {
		if (!this.userdata) {
			this.userdata = {};
		}
		if (!this.userdata[id]) {
			this.userdata[id] = {};
		}
		this.userdata[id][name] = value;
	};

	gantt._change_id = function(oldId, newId) {
		if (this._dp._ganttMode !== "task") {
			this.changeLinkId(oldId, newId);
		} else {
			this.changeTaskId(oldId, newId);
		}
	};

	gantt._row_style = function(rowId, classname){
		if (this._dp._ganttMode !== "task") {
			return;
		}
		if (!gantt.isTaskExists(rowId)) {
			return;
		}

		const task = gantt.getTask(rowId);
		task.$dataprocessor_class = classname;
		gantt.refreshTask(rowId);
	};

	// fake method for dataprocessor
	gantt._delete_task = function(rowId, node) {}; // tslint:disable-line

	gantt._sendTaskOrder = function(id, item){
		if (item.$drop_target) {
			this._dp.setGanttMode("task");
			this.getTask(id).target = item.$drop_target;
			this._dp.setUpdated(id, true,"order");
			delete this.getTask(id).$drop_target;
		}
	};

	gantt.setDp = function() {
		this._dp = dp;
	};

	gantt.setDp();
}